import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '../store/index.js'
// const routerPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
// 	return routerPush.call(this, location).catch(error => error)
// }
// import {
// 	MessageBox
// } from 'element-ui';
import Home from '../views/Home.vue'
import Learndetail from '../views/Learn-detail.vue'
// import User from '../views/User.vue'
Vue.use(VueRouter)

const routes = [
	// {
	// 	path:'/',
	// 	name:'mergeindex',
	// 	meta:{
	// 		title:"首页",
	// 		keepAlive: true,
	// 		isBack: false,
	// 		titles: "首页"
	// 	},
	// 	component: () => import( /* webpackChunkName: "merge" */ '../views/merge/index.vue'),
	// },
	{
		path: '/',
		name: 'Home',
		meta: {
			title: "翠麟社区",
			titles: "翠麟社区"

		},
		component: Home,
	},
	{
		path: '/competition/winner',
		name: '/competition/winner',
		meta: {
			title: "国际影展",
			keepAlive: true,
			isBack: false,
			titles: "国际影展"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Resource.vue'),

	},
	{
		path: '/competition/haipai',
		name: 'Study-detail',
		meta: {
			title: "海派新浪潮单元",
			titles: "海派新浪潮单元"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/merge/haiPai.vue'),
	},
	{
		path: '/cuilinhonor',
		name: 'cuilinhonor',
		meta: {
			title: "翠麟荣誉",
			titles: "翠麟荣誉"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/cuilinhonor.vue'),
	},
	{
		path: '/competition/haipai',
		name: 'Study-detail',
		meta: {
			title: "详情",
			titles: "详情"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Study-detail.vue'),

	},
	{
		path: '/Practice',
		name: 'Practice',
		meta: {
			title: "翠麟点映",
			keepAlive: true,
			isBack: false,
			titles: "翠麟点映"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Practice.vue'),

	},
	{
		path: '/Activity',
		name: 'Activity',
		meta: {
			title: "展映基地详情",
			keepAlive: true,
			isBack: false,
			titles: "展映基地详情"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Activity.vue'),

	},
	{
		path: '/creation/index',
		name: 'Learn',
		meta: {
			title: "创作训练营",
			keepAlive: true,
			isBack: false,
			titles: "创作训练营"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Learn.vue'),

	},


	{
		path: '/creation/detail',
		name: 'Learn-detail',
		meta: {
			title: "学习详情",
			titles: "学习详情",


		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		// component: () => import( /* webpackChunkName: "about" */ '../views/Learn-detail.vue')
		component: Learndetail,

	},


	{
		path: '/user/index',
		name: 'User',
		meta: {
			title: "会员中心",
			keepAlive: true,
			isBack: false,
			titles: "会员中心"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/User.vue')
	},
	{
		path: '/login',
		name: 'Login',
		meta: {
			title: "登录",
			titles: "登录"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Login.vue')
	},
	{
		path: '/register',
		name: 'Register',
		meta: {
			title: "注册",
			titles: "注册"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Register.vue')
	},
	{
		path: '/Find',
		name: 'Find',
		meta: {
			title: "忘记密码",
			titles: "忘记密码"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Find.vue'),

	},

	{
		path: '/success',
		name: 'success',
		meta: {
			title: "支付成功",
			titles: "支付成功"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/success.vue')
	},
	{
		path: '/Img',
		name: 'Img',
		meta: {
			title: "详情",
			titles: "详情"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Img.vue')
	},
	{
		path: '/alipay',
		name: 'alipay',
		meta: {
			title: "支付宝支付",
			titles: "支付宝支付"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/alipay.vue')
	},
	{
		path: '/legal',
		name: 'legal',
		meta: {
			title: "法律声明",
			keepAlive: true,
			isBack: false,
			titles: "法律声明"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/legal.vue'),

	},
	{
		path: '/contactus',
		name: 'contactus',
		meta: {
			title: "联系我们",
			keepAlive: true,
			isBack: false,
			titles: "联系我们"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/contactus.vue'),

	},

	{
		path: '/privacy',
		name: 'privacy',
		meta: {
			title: "隐私条款",
			keepAlive: true,
			isBack: false,
			titles: "隐私条款"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/privacy.vue'),

	},

	{
		path: '/service',
		name: 'service',
		meta: {
			title: "服务条款",
			keepAlive: true,
			isBack: false,
			titles: "服务条款"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/service.vue'),

	},

	{
		path: '/Learn-detailcopy',
		name: 'Learn-detailcopy',
		meta: {
			title: "学习详情",
			keepAlive: true,
			isBack: false,
			titles: "学习详情"
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Learn-detailcopy.vue'),

	},
	{
		path: '/Examcopy',
		name: 'Examcopy',
		meta: {
			title: "测试",
			keepAlive: true,
			isBack: false,
			titles: "测试"
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Examcopy.vue'),

	},
	{
		path: '/Exam',
		name: 'Exam',
		meta: {
			title: "考试",
			keepAlive: true,
			isBack: false,
			titles: "考试"
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Exam.vue'),

	},
	{
		path: '/Exam-detail',
		name: 'Exam-detail',
		meta: {
			title: "测试详情",
			titles: "测试详情"

		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Exam-detail.vue'),
	},
	{
		path: '/Datum',
		name: 'Datum',
		meta: {
			title: "服务中心",
			keepAlive: true,
			isBack: false,
			titles: "服务中心"
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/datum.vue'),

	},
	{
		path: '/read',
		name: 'read',
		meta: {
			title: "阅读",
			keepAlive: true,
			isBack: false,
			titles: "阅读"
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/read.vue'),
	},
	{
		path: '/null',
		name: 'null',
		meta: {
			title: "首页",
			keepAlive: true,
			isBack: false,
			titles: "首页"
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/null.vue'),
	},
	{
		path:'/Survey',
		name:'Survey',
		meta:{
			title:"创作者调研",
			keepAlive: true,
			isBack: false,
			titles: "创作者调研"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/Survey.vue'),

	},
	{
		path:'/Survey-detail',
		name:'Survey-detail',
		meta:{
			title:"创作者调研",
			keepAlive: true,
			isBack: false,
			titles: "创作者调研"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/Survey-detail.vue'),

	},
	{
		path:'/Survey-detail-my',
		name:'Survey-detail-my',
		meta:{
			title:"创作者调研",
			keepAlive: true,
			isBack: false,
			titles: "创作者调研"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/Survey-detail-my.vue'),

	},
	{
		path:'/crowd/index',
		name:'crowdfunding-list',
		meta:{
			title:"项目发现",
			keepAlive: true,
			isBack: false,
			titles: "项目发现"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/crowdfunding/list.vue'),
	},
	{
		path:'/crowd/detail',
		name:'crowdfunding-detail',
		meta:{
			title:"众筹详情",
			keepAlive: true,
			isBack: false,
			titles: "众筹详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/crowdfunding/detail.vue'),

	},
	{
		path:'/crowd/support-1',
		name:'crowdfunding-pay-1',
		meta:{
			title:"众筹详情",
			keepAlive: true,
			isBack: false,
			titles: "众筹详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/crowdfunding/pay-1.vue'),
	},
	{
		path:'/crowd/support-2',
		name:'crowdfunding-pay-2',
		meta:{
			title:"众筹详情",
			keepAlive: true,
			isBack: false,
			titles: "众筹详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/crowdfunding/pay-2.vue'),
	},{
		path:'/crowd/support-3',
		name:'crowdfunding-pay-3',
		meta:{
			title:"众筹详情",
			keepAlive: true,
			isBack: false,
			titles: "众筹详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/crowdfunding/pay-3.vue'),
	},{
		path:'/getOpenid',
		name:'getOpenid',
		meta:{
			title:"getOpenid",
			keepAlive: true,
			isBack: false,
			titles: "getOpenid"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/getOpenId.vue'),
	},{
		path:'/event/list',
		name:'eventlist',
		meta:{
			title:"活动列表",
			keepAlive: true,
			isBack: false,
			titles: "活动列表"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/event/list.vue'),
	},{
		path:'/event/detail',
		name:'eventdetail',
		meta:{
			title:"活动详情",
			keepAlive: true,
			isBack: false,
			titles: "活动详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/event/detail.vue'),
	},{
		path:'/event/pay-1',
		name:'eventpay1',
		meta:{
			title:"支付",
			keepAlive: true,
			isBack: false,
			titles: "支付"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/event/pay-1.vue'),
	},{
		path:'/event/pay-2',
		name:'eventpay2',
		meta:{
			title:"支付",
			keepAlive: true,
			isBack: false,
			titles: "支付"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/event/pay-2.vue'),
	},{
		path:'/event/pay-3',
		name:'eventpay3',
		meta:{
			title:"支付",
			keepAlive: true,
			isBack: false,
			titles: "支付"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/event/pay-3.vue'),
	},{
		path:'/about/shisw',
		name:'mergeabout',
		meta:{
			title:"关于我们",
			keepAlive: true,
			isBack: false,
			titles: "关于我们"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/About.vue'),
	},{
		path:'/competition/short',
		name:'mergecom1',
		meta:{
			title:"竞赛单元",
			keepAlive: true,
			isBack: false,
			titles: "竞赛单元"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/competition-1.vue'),
	},{
		path:'/competition/scenario',
		name:'mergecom2',
		meta:{
			title:"竞赛单元",
			keepAlive: true,
			isBack: false,
			titles: "竞赛单元"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/competition-2.vue'),
	},{
		path:'/merge/competition-3',
		name:'mergecom3',
		meta:{
			title:"竞赛单元",
			keepAlive: true,
			isBack: false,
			titles: "竞赛单元"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/competition-3.vue'),
	},{
		path:'/plan/media',
		name:'mergecre1',
		meta:{
			title:"创作扶持",
			keepAlive: true,
			isBack: false,
			titles: "创作扶持"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/creation-1.vue'),
	},{
		path:'/plan/index',
		name:'mergecre2',
		meta:{
			title:"创作扶持",
			keepAlive: true,
			isBack: false,
			titles: "创作扶持"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/creation-2.vue'),
	},{
		path:'/plan/league',
		name:'/plan/league',
		meta:{
			title:"国际电影人联盟",
			keepAlive: true,
			isBack: false,
			titles: "国际电影人联盟"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/league.vue'),
	},{
		path:'/merge/Activity',
		name:'mergecre3',
		meta:{
			title:"展映活动",
			keepAlive: true,
			isBack: false,
			titles: "展映活动"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/Activity.vue'),
	},{
		path:'/competition/apply',
		name:'mergeapp1',
		meta:{
			title:"报名方式",
			keepAlive: true,
			isBack: false,
			titles: "报名方式"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/apply-1.vue'),
	},{
		path:'/merge/apply-3',
		name:'mergeapp2',
		meta:{
			title:"报名方式",
			keepAlive: true,
			isBack: false,
			titles: "报名方式"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/apply-3.vue'),
	},{
		path:'/about/contact',
		name:'mergeContact',
		meta:{
			title:"联系我们",
			keepAlive: true,
			isBack: false,
			titles: "联系我们"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/Contact.vue'),
	},{
		path:'/merge/movie-list',
		name:'mergemovielist',
		meta:{
			title:"点播平台",
			keepAlive: true,
			isBack: false,
			titles: "点播平台"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/movie-list.vue'),
	},{
		path:'/merge/movie',
		name:'mergemovie',
		meta:{
			title:"云展映详情",
			keepAlive: true,
			isBack: false,
			titles: "云展映详情"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/movie.vue'),
	},{
		path:'/merge/mycompetition',
		name:'mergemycompetition',
		meta:{
			title:"我的作品",
			keepAlive: true,
			isBack: false,
			titles: "我的作品"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/mycompetition.vue'),
	},{
		path:'/merge/apply',
		name:'mergevolunteerapp',
		meta:{
			title:"报名志愿者",
			keepAlive: true,
			isBack: false,
			titles: "报名志愿者"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/volunteer-apply.vue'),
	},{
		path:'/merge/volunteer',
		name:'mergevolunteer',
		meta:{
			title:"志愿者团队",
			keepAlive: true,
			isBack: false,
			titles: "志愿者团队"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/volunteer.vue'),
	},{
		path:'/about/team',
		name:'mergeFounder',
		meta:{
			title:"创始人Founder",
			keepAlive: true,
			isBack: false,
			titles: "创始人Founder"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/Founder.vue'),
	},{
		path:'/merge/curator',
		name:'mergeCurator',
		meta:{
			title:"策展团队",
			keepAlive: true,
			isBack: false,
			titles: "策展团队"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/Curator.vue'),
	},{
		path:'/merge/jury',
		name:'mergeJury',
		meta:{
			title:"评审团Jury",
			keepAlive: true,
			isBack: false,
			titles: "评审团Jury"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/Jury.vue'),
	},{
		path:'/about/partner',
		name:'mergeParteners',
		meta:{
			title:"合作伙伴Parteners",
			keepAlive: true,
			isBack: false,
			titles: "合作伙伴Parteners"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/Parteners.vue'),
	},{
		path:'/merge/fill-form',
		name:'mergefill-form',
		meta:{
			title:"报名表",
			keepAlive: true,
			isBack: false,
			titles: "报名表"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/merge/fill-form.vue'),
	},{
		path:'/talent/index',
		name:'Talent',
		meta:{
			title:"翠麟精英",
			keepAlive: true,
			isBack: false,
			titles: "翠麟精英"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Talent.vue'),
	},{
		path:'/talent/detail',
		name:'Talent-detail',
		meta:{
			title:"翠麟精英",
			keepAlive: true,
			isBack: false,
			titles: "翠麟精英"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Talent-detail.vue'),
	},{
		path:'/preview/index',
		name:'Trailer',
		meta:{
			title:"国际销售代理",
			keepAlive: true,
			isBack: false,
			titles: "国际销售代理"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Trailer.vue'),
	},{
		path:'/preview/detail',
		name:'Trailer-detail',
		meta:{
			title:"国际销售代理",
			keepAlive: true,
			isBack: false,
			titles: "国际销售代理"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Trailer-detail.vue'),
	},{
		path:'/movie/index',
		name:'movie/index',
		meta:{
			title:"翠麟云剧场",
			keepAlive: true,
			isBack: false,
			titles: "翠麟云剧场"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Cinema.vue'),
	},{
		path:'/Cinema-list',
		name:'Cinema-list',
		meta:{
			title:"翠麟云剧场",
			keepAlive: true,
			isBack: false,
			titles: "翠麟云剧场"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Cinema-list.vue'),
	},{
		path:'/movie/detail',
		name:'Cinema-detail',
		meta:{
			title:"翠麟云剧场",
			keepAlive: true,
			isBack: false,
			titles: "翠麟云剧场"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Cinema-detail.vue'),
	},{
		path:'/news/index',
		name:'News',
		meta:{
			title:"新闻中心",
			keepAlive: true,
			isBack: false,
			titles: "新闻中心"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/News.vue'),
	},{
		path:'/news/detail',
		name:'News-detail',
		meta:{
			title:"新闻中心",
			keepAlive: true,
			isBack: false,
			titles: "新闻中心"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/News-detail.vue'),
	},{
		path:'/vod/index',
		name:'Cloud-exhibition',
		meta:{
			title:"点播平台",
			keepAlive: true,
			isBack: false,
			titles: "点播平台"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Cloud-exhibition.vue'),
	},{
		path:'/vod/detail',
		name:'CCloud-exhibition-detail',
		meta:{
			title:"云展映详情",
			keepAlive: true,
			isBack: false,
			titles: "云展映详情"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Cloud-exhibition-detail.vue'),
	},{
		path:'/Cinema',
		name:'Cinema',
		meta:{
			title:"翠麟云剧场",
			keepAlive: true,
			isBack: false,
			titles: "翠麟云剧场"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Cinema.vue'),
	},{
		path:'/showing/site/index',
		name:'showing/site/index',
		meta:{
			title:"翠麟点映",
			keepAlive: true,
			isBack: false,
			titles: "翠麟点映"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/showcased.vue'),
	},{
		path:'/showing/activity/detail',
		name:'showing-activity-detail',
		meta:{
			title:"展映基地活动详情",
			keepAlive: true,
			isBack: false,
			titles: "展映基地活动详情"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/showing-activity-detail.vue'),
	},{
		path:'/showing/site/detail',
		name:'showing-site-detail',
		meta:{
			title:"展映基地详情",
			keepAlive: true,
			isBack: false,
			titles: "展映基地详情"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/showing-site-detail.vue'),
	},{
		path:'/winnerList/index',
		name:'WinnerList',
		meta:{
			title:"获奖名单",
			keepAlive: true,
			isBack: false,
			titles: "获奖名单"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/WinnerList.vue'),
	},{
		path:'/winnerList/history',
		name:'Winnerhistory',
		meta:{
			title:"历史获奖名单",
			keepAlive: true,
			isBack: false,
			titles: "历史获奖名单"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Winnerhistory.vue'),
	},{
		path:'/about/cuilin',
		name:'WinnerList',
		meta:{
			title:"获奖名单",
			keepAlive: true,
			isBack: false,
			titles: "获奖名单"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/cuilin.vue'),
	},{
		path:'/page/service',
		name:'contract',
		meta:{
			title:"服务条款",
			keepAlive: true,
			isBack: false,
			titles: "服务条款"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/contract.vue'),
	},{ 
		path:'/competition/AICreativeImaging',
		name:'AICreativeImaging',
		meta:{
			title:"AI创意影像",
			keepAlive: true,
			isBack: false,
			titles: "AI创意影像"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/AICreativeImaging.vue'),
	},{ 
		path:'/photographer',
		name:'Photographer',
		meta:{
			title:"特约摄影师",
			keepAlive: true,
			isBack: false,
			titles: "特约摄影师"
		},
		component: () => import( /* webpackChunkName: "merge" */ '../views/Photographer.vue'),
	}
]
const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
